import classnames from 'classnames';
import noop from 'lodash/noop';
import { bool, func, node, string } from 'prop-types';
import React, { Component } from 'react';

export default class ComponentLoadingSection extends Component {
  static propTypes = {
    loading: bool.isRequired,
    children: node.isRequired,
    className: string,
    refHandler: func,
  };

  static defaultProps = {
    refHandler: noop,
  };

  static getDerivedStateFromProps(props, state) {
    return {
      animated: state.animated ? state.animated : props.loading,
    };
  }

  state = {};

  render() {
    const { refHandler, loading, className, children } = this.props;
    const { animated } = this.state;
    return (
      <section
        ref={refHandler}
        className={classnames(
          'component-loading-section',
          {
            'component-loading-section--animated': animated,
            'component-loading-section--animated-visible': animated && !loading,
          },
          className,
        )}
      >
        {children}
      </section>
    );
  }
}
